import styled from "styled-components";

export const StyledHeader = styled.header`
    max-width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem;
    -webkit-box-shadow: 0px 3px 2px 0px rgb(0 0 0 / 5%);
    box-shadow: 0px 3px 2px 0px rgb(0 0 0 / 5%);
`;
